<div class="estimation-items-step row" *ngIf="transportConfiguration">
  <div class="col-12">
    <jhi-bary-card titleKey="estimation-items.title" [tooltip]="'estimation-items.tooltip' | translate: { transporterName: transporter.shopName }">
      <ng-container body>
        <div class="col-12">
          <p class="gray" jhiTranslate="estimation-items.legalMentions" [translateValues]="{ transporterName: transporter.companyName }"></p>
        </div>
        <div class="col-12">
          <jhi-bary-input-select
            [label]="'estimation-items.input.label' | translate"
            [control]="transportForm.controls.itemsNature"
            id="estimation-items.itemsNature"
            [options]="insuranceItemsOption"
            data-id-cypress="select-marchandise"
          ></jhi-bary-input-select>
        </div>
        <div class="col-12" *ngFor="let transportItem of transportForm.controls.items; let isLast = last; index as index">
          <jhi-bary-transport-item-line
            [transportFormGroup]="transportForm"
            [item]="getValueForTransportItem(transportItem)"
            (deleteEvent)="removeTransportItem(index)"
            (editEvent)="initTransportItem(index)"
          ></jhi-bary-transport-item-line>
          <hr class="bary-hr" *ngIf="!isLast" />
        </div>
        <div class="col-12 mt-3" *ngIf="transportForm.showAddItem()">
          <jhi-bary-specific-button type="addMerchandise" (clickEvent)="initTransportItem()"></jhi-bary-specific-button>
        </div>
        <div class="form-row align-items-center" *ngIf="transportConfiguration.euroPalletAllowed">
          <div class="col-auto">
            <p class="bold mb-0" jhiTranslate="LABEL.EURO_PALLETS_TO_EXCHANGE">Palettes Europe à échanger</p>
          </div>
          <div class="col-auto my-auto">
            <div class="switch main-switch text-center">
              <label class="mb-0">
                <input type="checkbox" (change)="checkEuroPallets()" [checked]="isEuroPalletsNumberVisible" />
                <span class="lever"></span>
              </label>
            </div>
          </div>
          <div class="col-auto my-auto">
            <jhi-bary-input-number
              [control]="transportForm.controls.euroPallet"
              [class.invisible]="!isEuroPalletsNumberVisible"
              [min]="0"
              id="europe-pallet-number"
            ></jhi-bary-input-number>
          </div>
        </div>
        <div class="form-row align-items-center" *ngIf="transportConfiguration.includedInsurance">
          <div class="col-auto">
            <p class="bold mb-0" jhiTranslate="estimation-items.inculuded">Palettes Europe à échanger</p>
          </div>
          <div class="col-auto my-auto">
            <div class="switch main-switch text-center">
              <label class="mb-0">
                <input type="checkbox" (change)="checkEuroPallets()" [checked]="isEuroPalletsNumberVisible" />
                <span class="lever"></span>
              </label>
            </div>
          </div>
          <div class="col-auto my-auto">
            <jhi-bary-input-number
              [control]="transportForm.controls.euroPallet"
              [class.invisible]="!isEuroPalletsNumberVisible"
              [min]="0"
              id="included_insurance"
            ></jhi-bary-input-number>
          </div>
        </div>
      </ng-container>
    </jhi-bary-card>
  </div>
  <div class="col-12 mt-3">
    <jhi-insurance-row [optionInsurance]="optionInsurance" [transport]="transport" [transportForm]="transportForm"></jhi-insurance-row>
  </div>
</div>
